/**************************
 * Featured collection JS *
 **************************/

// Mettre à jour l'affichage des boutons de scroll
function update_scroll_buttons(section, collection) 
{
    let scroll_container = section.getElementsByClassName('scroll_container')[0];

    if(!scroll_container)
        return;

    let buttons = scroll_container.getElementsByTagName('a');

    if(parseInt(collection.dataset.scroll) <= 0)
        buttons[0].classList.add('no_scroll');
    else
        buttons[0].classList.remove('no_scroll');

    if(parseInt(collection.dataset.scroll) >= collection.scrollWidth - collection.offsetWidth || collection.scrollWidth <= collection.offsetWidth)
        buttons[1].classList.add('no_scroll');
    else
        buttons[1].classList.remove('no_scroll');
}

// Change the collections tab on click 
function change_collections_tab(e, target, section, index) 
{
    e.preventDefault();

    // get the current section
    section = document.querySelector(`div[data-section-id=${section}]`);

    // remove class from all nodes with "collection_tab_selected" class
    let collection_tab_selected = section.getElementsByClassName('collection_tab_selected');

    for (let i = 0; i < collection_tab_selected.length; i++) {
        collection_tab_selected[i].classList.remove('collection_tab_selected');
    }

    target.parentNode.classList.add('collection_tab_selected');

    // remove class "collection_hidden" from all nodes with "collections_list" class
    let collections = section.getElementsByClassName('collections_list');

    for (let i = 0; i < collections.length; i++) 
    {
        if(i != index - 1)
        {
            collections[i].classList.add('collection_hidden');
        }
    }    

    collections[index - 1].classList.remove('collection_hidden');
}

// Change the collection on click 
function change_collection(e, target, section, index) 
{
    e.preventDefault();

    // get the current section
    section = document.getElementById('CollectionSection-' + section);

    // remove class from all nodes with "collection_tab_selected" class
    let collection_tab_selected = section.getElementsByClassName('collection_tab_selected');

    for (let i = 0; i < collection_tab_selected.length; i++) {
        collection_tab_selected[i].classList.remove('collection_tab_selected');
    }

    target.parentNode.classList.add('collection_tab_selected');

    // remove class from all nodes with "collection_tab" class
    let collections = section.getElementsByClassName('collection_tab');
    
    for (let i = 0; i < collections.length; i++) {
        if(i == index - 1)
        {
            collections[i].classList.remove('collection_hidden');
            update_scroll_buttons(section, collections[i]);
        }     
        else
            collections[i].classList.add('collection_hidden');
    }    
}

// Afficher une collection donnée
function afficher_collection(e, section, collectionHandle)
{
    e.preventDefault();
    // get the current section
    section = document.getElementById('CollectionSection-' + section);

    let collection_tab = section.getElementsByClassName('collection_tab_selected')[0];

    if(collection_tab)
    {
        document.location = collection_tab.getElementsByTagName('a')[0].rel;
    }
    else
    {
        document.location = '/collections/' + collectionHandle
    }  
}

// General scroll products function
function scroll_collection(container, collection, products, direction)
{
    if(direction == 'left')
    {
        for(let i = products.length - 1; i >= 0; --i)
        {
            if(products[i].getBoundingClientRect().left < collection.getBoundingClientRect().left)
            {
                collection.dataset.scroll = products[i].getBoundingClientRect().left - products[0].getBoundingClientRect().left - collection.offsetWidth + products[i].offsetWidth;
                break;
            }
        }  
    }
    else if(direction == 'right')
    {
        for(const product of products)
        {
            if(product.getBoundingClientRect().right > collection.getBoundingClientRect().left + collection.offsetWidth)
            {
                collection.dataset.scroll = product.getBoundingClientRect().left - products[0].getBoundingClientRect().left;
                break;
            }
        }
    }   

    if(parseInt(collection.dataset.scroll) < 0)
        collection.dataset.scroll = 0;
    else if(parseInt(collection.dataset.scroll) > collection.scrollWidth)
        collection.dataset.scroll = collection.scrollWidth - collection.offsetWidth;

    collection.scrollTo({ left: parseInt(collection.dataset.scroll), top: 0, behavior: 'smooth' });

    // scrollTo n'est pas supporté par Safari
    if(window.safari)
    {
        collection.scrollLeft = parseInt(collection.dataset.scroll);
    }

    // console.log(collection.dataset.scroll);

    update_scroll_buttons(container, collection);
}

// Function to scroll the collection container
function scroll_section_collection(e, target, section_id, direction)
{
    e.preventDefault();

    if(target.classList.contains('no_scroll'))
        return;

    // get the current section
    let section = document.getElementById('CollectionSection-' + section_id);
    let collection = section.querySelector('.collection_tab:not(.collection_hidden)');
    let products = collection.getElementsByClassName('grid-product');

    scroll_collection(section, collection, products, direction);
}

// Function to scroll the collection container inside a block
function scroll_block_collection(e, target, block_id, direction)
{
    e.preventDefault();

    if(target.classList.contains('no_scroll'))
        return;

    // get the current section
    let block = document.querySelector(`div[data-block-id="${block_id}"]`);
    let collection = block.querySelector('.collection_tab');
    let products = collection.getElementsByClassName('grid-product');

    scroll_collection(block, collection, products, direction);
}

// Afficher un accordeon
function toggleAccordeon(target) 
{
    let parent = target.parentNode;
    let accordeon = parent.querySelector('.accordeon, .accordeon-mobile');

    accordeon.classList.toggle('accordeon_active');

    if(accordeon.classList.contains('accordeon_active'))
    {
        parent.getElementsByClassName('toggle_up_accordeon')[0].classList.remove('accordeon_hidden');
        parent.getElementsByClassName('toggle_down_accordeon')[0].classList.add('accordeon_hidden');
    } else
    {
        parent.getElementsByClassName('toggle_up_accordeon')[0].classList.add('accordeon_hidden');
        parent.getElementsByClassName('toggle_down_accordeon')[0].classList.remove('accordeon_hidden');
    }
}

// Prevent propagation
function prevent(event)
{
    event.preventDefault();
    event.stopPropagation();
}

// Search inside filters
function filter_search(event, target)
{
    prevent(event);

    const list = target.parentNode.querySelector('.tag-list');
    
    for(const tag of list.children)
    {
        const label = tag.querySelector('.tag__text');

        if(label.innerHTML.toLowerCase().startsWith(target.value.toLowerCase()))
            tag.classList.remove('hidden')
        else
            tag.classList.add('hidden');
    }
}

function metafield_section_scroll(target) 
{
    const sections = target.getElementsByClassName('feature-section-wrapper');

    let selected = target.querySelector('.feature-section-selected');

    if(!selected)
    {
        sections[0].classList.add('feature-section-selected');
        selected = sections[0];
    }

    let index = Array.from(selected.parentNode.children).indexOf(selected);

    let width = selected.getBoundingClientRect().width;
    let gap = parseInt(getComputedStyle(target).gap.match('[0-9]+')[0]);

    if(selected.getBoundingClientRect().left < target.getBoundingClientRect().left)
    {
        index++;
        selected = sections[index];
    }
    else if(selected.getBoundingClientRect().right > target.getBoundingClientRect().left + width + gap * 2)
    {
        index--;
        selected = sections[index];
    }

    if(!selected)
        return;

    target.querySelector('.feature-section-selected').classList.remove('feature-section-selected');
    selected.classList.add('feature-section-selected');

    let scroll = index * (width + gap);

    target.style.overflow = "hidden";
    target.scroll({ left: scroll, top: 0, behavior: 'smooth' });

    setTimeout(() => {
        target.style.overflow = "";
    }, 10);

    if(window.safari)
    {
        target.scrollLeft = scroll;
    }
}

/*// Recherche predictive
function predictive_search(target) 
{
    var q = target.value;
    var b = '&resources[type]=product'

    fetch('/search/suggest.json?q=' + q + b)
        .then(function(response) {
            return response.json();
        }).then(function(json) {
            console.log(json);
        })

        // };
        //     var productSuggestions = response.resources.results.products;
        //     if (productSuggestions.length > 0) {
        //     $("#searchResults").empty()
        //     $(productSuggestions).each(function() {
        //         $("#searchResults").append(
        //         '<li class="list-group-item list-group-item-action d-flex align-items-center"><div class="image-parent mr-3"><img class="img-fluid" src="' + this.featured_image.url + '"/></div><div><p class="mb-0">'+ this.title +'</p><small>' + this.body + '</small></div><p class="ms-auto">' + this.price + '</p></li>'
        //         );
        //         console.log(this.title);
        //         console.log(this.price);
        //         console.log(this.featured_image.url);
        //     });
        //     } else {
        //     $("#searchResults").empty().append(
        //         '<li class="list-group-item list-group-item-action d-flex align-items-center"><small>No Results Found</small></li>'
        //     );
        //     }
        // }
    // );
}*/

function showHtmlDiv() {
  var htmlShow = document.getElementById("scDiscountApp");
  var element = document.getElementById("applycode");
  if (htmlShow.style.display === "block") {
    htmlShow.style.display = "none";
    element.classList.remove("opclass");
  } else {
    htmlShow.style.display = "block";
    element.classList.add("opclass");
  }
}



if ($(window).width() > 768) {
 $(document).ready(function() {
    $(".video-wrapper-product-featured").insertAfter(".feature-section-wrapper:first-of-type");
});   
}
if ($(window).width() < 768) {
 $(document).ready(function() {
   $(".product_pictogrammes_container").slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  infinite: true,
  autoplaySpeed: 3000,
  speed: 1000,
  arrows: false,
  dots: false,
  autoplay: true,
  pauseOnHover:false,
});
});   
}

document.addEventListener('DOMContentLoaded', function () {
  var content = document.getElementById('drop_down_option');
  var toggleButton = document.getElementById('drop_down_select');

  toggleButton.addEventListener('click', function () {
    this.classList.toggle('svg_dev');
    content.classList.toggle('hidden_dev');
  });
});

$(document).ready(function(){
            $(".product__thumbs--scroller.mobilescrool .product__thumb-item").click(function(){
                // Remove 'active' class from all elements
                $(".product__thumbs--scroller.mobilescrool .product__thumb-item").removeClass("activ");

                // Add 'active' class to the clicked element
                $(this).addClass("activ");
            });
        });


if ($(window).width() < 769) {
$(document).ready(function(){
  var mainIndexa = $(".product-main-slide.is-selected").data("index");
  $(".mobilescrool .product__thumb-item[data-index='" + mainIndexa + "']").addClass("activ"); 


 
  
});    
}

$(function() {    
    setTimeout(function() {
        $(".hero-toplogo_au").hide()
    }, 5000);
});

let tbs_nodes = document.querySelectorAll('.product-block--tab + .product-block--tab');
for (let i = 0; i < tbs_nodes.length; i++) {
    if (tbs_nodes[i].classList.contains('product-block--tab')) {
      tbs_nodes[i].querySelector('.collapsibles-wrapper > button').classList.add('is-open');
      tbs_nodes[i].querySelector('.collapsibles-wrapper > div').classList.add('is-open'); 
	  break;
   }
}

document.addEventListener('DOMContentLoaded', function() {
  if ($(window).width() < 750) {
     $('#join-widget-delsey-paris-int').insertAfter('.product-block.product-formmain .product-block');
     //$('.product-single__header--mobile').insertBefore('.product-single__meta');
  } 
});

//if ($(window).width() < 769) {
 $(document).ready(function() {

$('.section-advanced-content .product-metafields-sections').on('init', function (event, slick, direction) {    
    if (!($('.section-advanced-content .product-metafields-sections .slick-slide').length > 0)) {        
        $('body.template-product .section-advanced-content').hide();
    }
});

   
   $(".section-advanced-content .product-metafields-sections").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  autoplaySpeed: 5000,
  speed: 500,
  arrows: true,
  dots: true,
  autoplay: true,
  pauseOnHover:false,
  responsive: [
    {      
      breakpoint: 989,
      settings: {
        slidesToShow: 2,
        arrows: false
      }
    },
    {      
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        arrows: false
      }
    }
  ]   
});
 $('.section-advanced-content .product-metafields-sections').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.feature-row__item').removeClass('showcontent');
    $('.arowws').removeClass('active');
  });
});   


$(document).ready(function() {   
  var lineHeight = 19.2;
  $('.section-advanced-content .featured-row__subtext').each(function(index, element) { 
   var divHeight = $(this).height();
        var lineCount = Math.floor(divHeight / lineHeight);        
        if (lineCount > 4) {            
            $(this).addClass('subhidecontant');
            $(this).after('<div class="arowws"></div>'); 
         
        }
   });
  
 $('.arowws').click(function() {
   $(this).toggleClass('active');  
   $(this).parent().toggleClass('showcontent');
  });  
});  
//}


if ($(window).width() < 768) {
 $(document).ready(function() {
   $(".multirow__inner_rss").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  autoplaySpeed: 3000,
  speed: 1000,
  arrows: false,
  dots: true,
  autoplay: false,
  pauseOnHover:false,
});
});   
}

if ($(window).width() < 768) {
 $(document).ready(function() {
   $(".new_image_text_rss").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  autoplaySpeed: 3000,
  speed: 1000,
  arrows: false,
  dots: true,
  autoplay: false,
  pauseOnHover:false,
});
});   
}

if ($(window).width() < 768) { 
 $(document).ready(function() {
   $(".new_rss_image_column .new_rss_image_column_main").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  autoplaySpeed: 3000,
  speed: 1000,
  arrows: false,
  dots: true,
  autoplay: false,
  pauseOnHover:false,
});
});   
}

if ($(window).width() < 768) { 
 $(document).ready(function() {
   $(".new_rss_discover_pr .rss_discover-items").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  autoplaySpeed: 3000,
  speed: 1000,
  arrows: false,
  dots: true,
  autoplay: false,
  pauseOnHover:false,
});
});   
}

 $(document).ready(function() {
   $(".on-video-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  autoplaySpeed: 40000,
  speed: 1000,
  arrows: false,
  dots: true,
  autoplay: true,
  pauseOnHover:true,
});
});  